// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DriveTimePdf .SkyhopPdfHeader {
  flex-direction: column;
  justify-content: center;
  background-color: var(--bs-primary);
  padding-bottom: 2rem;
}
.DriveTimePdf .SkyhopPdfHeader-Title {
  text-align: center;
  color: #fff;
  gap: 1rem;
}
.DriveTimePdf .SkyhopPdfHeader-Title .Title {
  padding-top: 0.75rem;
  font-size: 1.5rem;
}
.DriveTimePdf .SkyhopPdfHeader-Title .Subtitle {
  text-transform: none;
  font-size: 1rem;
}
.DriveTimePdf .card {
  border: none;
  box-shadow: none;
}
.DriveTimePdf .TimeIntervalStats .CardHeader {
  display: none;
}
.DriveTimePdf .TimeIntervalStats .TableRow-Header.TimeIntervalRow {
  background-color: var(--bs-primary);
  color: #fff;
  padding: 0.5rem 0;
}
.DriveTimePdf .TimeIntervalStats .TableRow-Header.TimeIntervalRow .SortingIndicator {
  display: none;
}
.DriveTimePdf .TimeIntervalStats .Table-Body .TableRow .WeekdayAvgCell,
.DriveTimePdf .TimeIntervalStats .Table-Body .TableRow .WeekendAvgCell {
  background-color: rgba(242, 242, 242, 0.5);
}
.DriveTimePdf .DriveTimeTool-Chart {
  page-break-inside: avoid !important;
}
.DriveTimePdf .DriveTimeTool-Chart .card {
  padding: 0 var(--pdf-spacing);
}
.DriveTimePdf .DriveTimeTool-Chart .DriveTimeScatterPlot .scatter-plot-header {
  display: none;
}
.DriveTimePdf .DriveTimeTool-Chart .DriveTimeScatterPlot .scatter-plot-content {
  display: initial;
}
.DriveTimePdf .DriveTimeTool-Chart .DriveTimeDeviations .deviations-header {
  display: none;
}
.DriveTimePdf .DriveTimeTool-Chart .DriveTimeDeviations .deviations-content {
  display: initial;
}`, "",{"version":3,"sources":["webpack://./src/features/PdfLayout/layouts/DriveTimePdf/styles.scss"],"names":[],"mappings":"AACE;EACE,sBAAA;EACA,uBAAA;EACA,mCAAA;EACA,oBAAA;AAAJ;AAEE;EACE,kBAAA;EACA,WAAA;EACA,SAAA;AAAJ;AACI;EACE,oBAAA;EACA,iBAAA;AACN;AACI;EACE,oBAAA;EACA,eAAA;AACN;AAEE;EACE,YAAA;EACA,gBAAA;AAAJ;AAGI;EACE,aAAA;AADN;AAGI;EACE,mCAAA;EACA,WAAA;EACA,iBAAA;AADN;AAEM;EACE,aAAA;AAAR;AAKQ;;EAEE,0CAAA;AAHV;AAQE;EACE,mCAAA;AANJ;AAOI;EACE,6BAAA;AALN;AAQM;EACE,aAAA;AANR;AAQM;EACE,gBAAA;AANR;AAUM;EACE,aAAA;AARR;AAUM;EACE,gBAAA;AARR","sourcesContent":[".DriveTimePdf {\n  .SkyhopPdfHeader {\n    flex-direction: column;\n    justify-content: center;\n    background-color: var(--bs-primary);\n    padding-bottom: 2rem;\n  }\n  .SkyhopPdfHeader-Title {\n    text-align: center;\n    color: #fff;\n    gap: 1rem;\n    .Title {\n      padding-top: 0.75rem;\n      font-size: 1.5rem;\n    }\n    .Subtitle {\n      text-transform: none;\n      font-size: 1rem;\n    }\n  }\n  .card {\n    border: none;\n    box-shadow: none;\n  }\n  .TimeIntervalStats {\n    .CardHeader {\n      display: none;\n    }\n    .TableRow-Header.TimeIntervalRow {\n      background-color: var(--bs-primary);\n      color: #fff;\n      padding: 0.5rem 0;\n      .SortingIndicator {\n        display: none;\n      }\n    }\n    .Table-Body {\n      .TableRow {\n        .WeekdayAvgCell,\n        .WeekendAvgCell {\n          background-color: rgba(242, 242, 242, 0.5);\n        }\n      }\n    }\n  }\n  .DriveTimeTool-Chart {\n    page-break-inside: avoid !important;\n    .card {\n      padding: 0 var(--pdf-spacing);\n    }\n    .DriveTimeScatterPlot {\n      .scatter-plot-header {\n        display: none;\n      }\n      .scatter-plot-content {\n        display: initial;\n      }\n    }\n    .DriveTimeDeviations {\n      .deviations-header {\n        display: none;\n      }\n      .deviations-content {\n        display: initial;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
